'use client'

import { sendGTMEvent } from '@next/third-parties/google'
import { useRouter } from 'next/navigation'
import { useCallback } from 'react'
import { buildGA4EventModel } from '@/components/@analitycs/push-ecommerce-event'
import { bff_client } from '@/lib/apiClient'
import type { EnrolmentResponseType } from '@/types/enrolment-type'
import {
  type CreateEnrolmentType,
  createEnrollmentSchema,
} from '@/validation/create-enrollment'

export const useCreateEnrolment = () => {
  useRouter()

  const handleSubmit = useCallback(
    async (
      createEnrolment: CreateEnrolmentType
    ): Promise<EnrolmentResponseType | null> => {
      try {
        const data = createEnrollmentSchema.parse(createEnrolment)

        const response: {
          enrolmentResponse: EnrolmentResponseType
          orderResponse?: {
            object: {
              enrolment_id: string
              product: {
                amount: number
                name: string
              }
            }
          }
        } = await bff_client
          .post('enrolment', {
            json: data,
          })
          .then(res => res.json())

        const { enrolmentResponse, orderResponse } = response

        if (orderResponse?.object) {
          const eventModel = await buildGA4EventModel({
            currency: 'BRL',
            value: orderResponse.object.product.amount,
            items: [
              {
                id: data.product_id,
                name: orderResponse.object.product.name,
                price: orderResponse.object.product.amount,
                quantity: 1,
              },
            ],
          })

          sendGTMEvent({ ecommerce: null })
          sendGTMEvent({
            event: 'add_to_cart',
            eventModel,
            ecommerce: eventModel,
            content_ids: orderResponse.object.enrolment_id,
            ...(eventModel.user_data && { user_data: eventModel.user_data }),
          })
        }

        return enrolmentResponse
      } catch {
        return null
      }
    },
    []
  )

  return { handleSubmit }
}
